module.exports = __webpack_public_path__ + "img/ic_16_arrow_white.86b734bb.svg";